import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';
import AddToCart from './AddToCart';
import BASE_URL from '../../config';

const ProductDetailDe = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(''); // 'success' or 'danger'
  const [addedToCart, setAddedToCart] = useState(false);

  useEffect(() => {
    axios.get(`${BASE_URL}/api/product/${slug}/?format=json`)
      .then(response => {
        setProduct(response.data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });

    // Ensure anonymous user ID exists
    const anonymousUserID = localStorage.getItem('anonymousUserID');
    if (!anonymousUserID) {
      axios.get(`${BASE_URL}/api/anonymous-user/`)
        .then(response => {
          localStorage.setItem('anonymousUserID', response.data.anonymous_user_id);
        })
        .catch(error => {
          console.error('Error fetching anonymous user ID:', error);
        });
    }
  }, [slug]);

  const handleViewCart = () => {
    navigate('/cart');
  };

  // Show loading or error
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  // Set message with type (helper to be passed into AddToCart)
  const showMessage = (text, type = 'danger') => {
    setMessage(text);
    setMessageType(type);

    // Optional: auto-dismiss after 3 seconds
    setTimeout(() => {
      setMessage(null);
      setMessageType('');
    }, 3000);
  };

  return (
    <div className="container mt-4">
      {product && (
        <>
          <Carousel className="mb-4">
            {product.images.map((img, index) => (
              <Carousel.Item key={index}>
                <img src={img.image} alt={`Slide ${index + 1}`} className="d-block w-100" />
              </Carousel.Item>
            ))}
          </Carousel>

          <h1>{product.title}</h1>
          <p>{product.description}</p>
          <p><strong>Category:</strong> {product.category.name}</p>
          <p><strong>Price:</strong> ${product.price}</p>
          <p><strong>Discount Price:</strong> ${product.discount_price}</p>
          <p><strong>Label:</strong> {product.label}</p>

          {/* ✅ Alert message */}
          {message && (
            <div className={`alert alert-${messageType} mt-3`} role="alert">
              {message}
            </div>
          )}

          {addedToCart ? (
            <button className="btn btn-primary mt-3" onClick={handleViewCart}>View Cart</button>
          ) : (
            <AddToCart
              product={product}
              setAddedToCart={setAddedToCart}
              setMessage={(msg) => showMessage(msg, 'danger')} // Default to error
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProductDetailDe;
